import { IconNames, Text } from '@dixa/lib-shared-habla';
import { v4 as uuid } from 'uuid';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import {
  FlowNode,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { PowerEmailFlowExtraDataT } from '../PowerEmailFlow';

type FlowEmailNodeInitTypeT = FlowNodeTypes.INIT;
export type FlowEmailNodeInitT = NodeT<FlowEmailNodeInitTypeT>;

export class InitNode extends NodeTypeComponent<
  FlowEmailNodeInitT,
  PowerEmailFlowExtraDataT
>() {
  static icon: IconNames = 'chat';
  static label = 'Incoming email';
  static translatePayload = (node: FlowEmailNodeInitT): RegisterPortT[] => {
    return [
      {
        id: uuid(),
        type: 'out',
        label: 'arrow',
        connection: node.childIds.length === 1 ? node.childIds[0] : null,
      },
    ];
  };
  static updateConnection = (
    node: FlowEmailNodeInitT,
    _port: InternalPortT,
    newConnection: string,
  ): FlowEmailNodeInitT => ({ ...node, childIds: [newConnection] });

  render() {
    const {
      extraData: { name },
    } = this.props;
    const displayName = name || 'Name your flow';

    return (
      <FlowNode
        color={InitNode.color}
        icon={InitNode.icon}
        label={InitNode.label}
        text={
          <Text.Paragraph clamp={1}>
            To <strong>{displayName}</strong>
          </Text.Paragraph>
        }
      />
    );
  }
}
